import { ChangeType } from '../DiffReport';
import { Theme } from '../DeltaResult';
import { ViewChangeWord } from '../DiffReport';

import * as monaco from "monaco-editor/esm/vs/editor/editor.api";

export class MonacoStyles {

  static getGutterStyleName(theme: Theme, type: ChangeType) {
    let result = '';
    switch (theme) {
      case Theme.VSDark:
        switch (type) {
          case ChangeType.Modified:
            result = 'modifiedBackgroundDark';
            break;
          case ChangeType.Inserted:
            result = 'insertedBackgroundDark';
            break;
          case ChangeType.Removed:
            result = 'removedBackgroundDark';
            break;
        }
      break;
      case Theme.VSLight:
        switch (type) {
          case ChangeType.Modified:
            result = 'modifiedBackgroundDark';
            break;
          case ChangeType.Inserted:
            result = 'insertedBackgroundDark';
            break;
          case ChangeType.Removed:
            result = 'removedBackgroundDark';
            break;
        }
      break;
    }
    return result;
  }

  static getInlineStyleName(theme: Theme, type: ChangeType) {
    let result = '';
    switch (theme) {
      case Theme.VSDark:
        switch (type) {
          case ChangeType.Modified:
            result = 'modifiedBackgroundDark';
            break;
          case ChangeType.Inserted:
            result = 'insertedInlineBackgroundDark';
            break;
          case ChangeType.Removed:
            result = 'removedInlineBackgroundDark';
            break;
        }
      break;
      case Theme.VSLight:
        switch (type) {
          case ChangeType.Modified:
            result = 'modifiedBackgroundDark';
            break;
          case ChangeType.Inserted:
            result = 'insertedInlineBackgroundDark';
            break;
          case ChangeType.Removed:
            result = 'removedInlineBackgroundDark';
            break;
        }
        break;
    }
    return result;
  }

  static getLineStyleName(theme: Theme, type: ChangeType) {
    let result = '';
    switch (theme) {
      case Theme.VSDark:
        switch (type) {
          case ChangeType.Inserted:
            result = 'insertedLineBackgroundDark';
            break;
          case ChangeType.Removed:
            result = 'removedLineBackgroundDark';
            break;
        }
      break;
      case Theme.VSLight:
        switch (type) {
          case ChangeType.Inserted:
            result = 'insertedLineBackgroundDark';
            break;
          case ChangeType.Removed:
            result = 'removedLineBackgroundDark';
            break;
        }
        break;
    }
    return result;
  }

  static pushDiffViewWordDec(viewChange: ViewChangeWord, deltaDecorations: monaco.editor.IModelDeltaDecoration[], theme: Theme) {
    const className = this.getInlineStyleName(theme, viewChange.changeType);
    const line = viewChange.line;

    const deltaDec: monaco.editor.IModelDeltaDecoration = {
      range: new monaco.Range(line, viewChange.startChar, line, viewChange.endChar),
      options: { inlineClassName: className }
    };
    deltaDecorations.push(deltaDec);
  }
}